import React, { useRef } from 'react';

import FaultControlHeader from './FaultControlHeader';
import BuilderSidePanel from './BuilderSidePanel';

import ContentEditable from 'react-contenteditable';

import * as classes from './FaultControl.module.css';

const FaultControl = ({
    connectorsClicked,
    ...props
}) => {

    const innerEditor = useRef(null);
    const text = useRef('');

    //const handleChange = evt => {
    //    parseHtml(evt.target.value);

    //    let string = '';

    //    if (evt.target.value.includes('if-block')) {
    //        string = string + 'If '
    //        if (evt.target.value.includes('variable')) {
    //            string = string + ' Variable A ';
    //        }

    //        if (evt.target.value.includes('+')) {
    //            string = string + ' + ';
    //        }

    //        if (evt.target.value.includes('if-block')) {
    //            string = string + ' Variable B ';
    //        }

    //        if (evt.target.value.includes(' =')) {
    //            string = string + ' = ';
    //        }
    //    }

    //    text.current = evt.target.value;
    //};

    //const parseHtml = html => {
    //    var parser = new DOMParser();
    //    var htmlDoc = parser.parseFromString(html, 'text/html');
    //    var divs = document.getElementsByTagName('div');

    //    let string = '';

    //    let ifArray = Array.from(divs).filter(item => item.id.includes('block-if'));

    //    ifArray.forEach(item => {
    //        console.log('Array Item: ', item);
    //    });

    //};

    return (
        <div className={classes.EditorColContainer} style={props.mode === 'formula' ? { overflowY: 'auto' } : { overflowY: 'auto' }}>
            <BuilderSidePanel />
            <div className={`${classes.Editor} ${classes.Formulabuttons}`}>
                <FaultControlHeader connectorsClicked={connectorsClicked} />
                <div className="ccb-editor-container" style={{ height: '100%', marginLeft: 15 }}>
                    <ContentEditable
                        id="formula-editor"
                        disabled={false}
                        innerRef={innerEditor} style={props.mode === 'formula' ? { minHeight: '50rem', height: '90%', fontSize: 15 } : { minHeight: '50rem', height: '90%', fontSize: 15 }}
                        html={text.current}
                        //onChange={handleChange}
                    />
                </div>
            </div>
        </div>
    );
};

export default FaultControl;
